function now() {
    return Date.now() / 1000 | 0;
}

if (!window.$requestUtil) {
    window.$requestUtil = {
        sstm: now(),
        request_id: 0,
        uuid: $util.uuidv4(),
        infoReported: false,
        ccpSessionId: undefined,
        clientLabel: 'IB'
    };
}

export const uuid = $requestUtil.uuid;
export const sstm = $requestUtil.sstm;

export const logger = (str, bypass) => {
    if(bypass) str=null;
    if(window.nativeConsole && typeof nativeConsole.log === 'function') {
        nativeConsole.log(str);
    }
    if(typeof window.__logger === 'function') {
        window.__logger(str);
    } else if(Array.isArray(window.__logs)) {
        __logs.push([ new Date().toLocaleString(), str ]);
    }
}

const notifySessionExpire = () => {
    $app.send({"action":"sso_validation_failed"});
}

class Requester {
    constructor() {
        this.headers = {};
        this.baseUrlOverride = "";
        this.paramsPreprocessors = [];
    }

    getBase() {
        let base = `${document.location.origin}/tws.proxy`;
        try {
            if(PROCESS_ENDPOINT !== undefined) {
                base = PROCESS_ENDPOINT;
            }
        } catch(e) {}
        return (this.baseUrlOverride || base);
    }

    formatUrl(url) {
        if(url.indexOf('http') === 0) {
            return url;
        } else {
            return this.getBase() + '/' + url;
        }
    }

    addParamsPreprocessor(fn) {
        this.paramsPreprocessors.push(fn);
        return () => {
            this.paramsPreprocessors = this.paramsPreprocessors.filter(p => p !== fn);
        }
    }

    formatParams(params) {
        const XYZAB_cookie = $util.cookie('XYZAB');
        // const USERID_cookie = $util.cookie('USERID');

        //validates XYZAB cookie for typical IB XYZAB and JWT style
        const validateCookie = (cookieVal) => {
            if(
                cookieVal !== null &&
                cookieVal !== undefined &&
                (''+cookieVal).toLowerCase() !== 'null' &&
                (''+cookieVal).toLowerCase() !== 'undefined' &&
                /^[a-zA-Z0-9!@#$&()`.+,/"-]/i.exec(cookieVal)
            ) {
                return true;
            }
            return false;
        }

        let headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'x-session-id': $requestUtil.uuid,
            'x-request-id': $requestUtil.request_id++,
            "X-SERVICE": $build.platform === "web" ? "AM.LOGIN" : "WEB_APP_ACTION",
            "x-embedded-in": $build.platform,
            "X-WA-VERSION": $build.rev + "/" + $build.date,
            "x-ccp-session-id": $requestUtil.ccpSessionId,
            "x-client-label": $requestUtil.clientLabel
        };

        if(validateCookie(XYZAB_cookie)) {
            headers['X-XYZAB'] = XYZAB_cookie;
        }

        // if(validateCookie(USERID_cookie)) {
        //     headers['X-USERID'] = USERID_cookie;
        // }

        let paramsDefault = {
            credentials: 'include',
            headers,
            ...params
        };

        return this.paramsPreprocessors.reduce((acc, v) => { acc = v(acc); return acc; }, paramsDefault);
    }

    overrideBase(newBase) {
        this.baseUrlOverride = newBase;
    }

    request(url, params, bypass) {
       logger(`WA > requesting ${url} with params ${JSON.stringify(params)}`, bypass);
        return fetch(this.formatUrl(url), this.formatParams(params))
            .then(v => {
                if(!v.ok) {
                    const i = {
                        webAppId: window.__appName,
                        userAgent: window?.navigator?.userAgent,
                        navigatorPlatform: window?.navigator?.platform,
                        navigatorAppVersion: window?.navigator?.appVersion,
                        ibTheme: $app.option.theme,
                        ibPlatform: $build.platform,
                        ibLang: $app.option.language,
                        ibMedia: $media,
                        ibDevice: $device,
                        cpRegion: window.region,
                        errorType: 'REST',
                        statusCode: v.status,
                        errorMessage: v.statusText,
                        errorInfo: v.url,
                        gitRev: $build?.rev
                    };
                    // instance.reportTelemetry({ a: 'webui_error', i });
                };
                if(v.clone) {
                    var cloneResponse = v.clone();
                    if(cloneResponse && cloneResponse.status && cloneResponse.status.toString() === '401') {
                        notifySessionExpire();
                        return Promise.reject(new Error("Session expired"));
                    }
                    if(!cloneResponse.ok) {
                        cloneResponse.text().then(text => {
                            logger(`WA > ${url} FAILED with response ${text} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`, bypass);
                        }).catch(e => {
                            logger(`WA > ${url} FAILED with response error message ${e ? e.message : 'Unknown'} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`, bypass);
                        })
                    } else {
                        cloneResponse.text().then(text => {
                            logger(`WA > ${url} SUCCESS with response ${text} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`,bypass);
                        }).catch(e => {
                            logger(`WA > ${url} FAILED with response error message ${e ? e.message : 'Unknown'} statusText ${cloneResponse.statusText} statusCode ${cloneResponse.status}`, bypass);
                        })
                    }
                } else {
                    logger(`WA > ${url} SUCCESS with response ${v} statusText ${v && v.statusText} statusCode ${v && v.status}`, bypass);
                }
                return v;
            })
            .catch(e => {
                logger(`WA > ${url} FAILED with response ${e ? e.message : 'Unknown'}`, bypass);
                return e;
            })
    }

    nonAuthTelemetry(body) {
        return this.request('telemetry/noAuthAdd', {
            method: 'POST',
            body: JSON.stringify(body)
        })
        .then(r => {
            if(r.ok) {
                return r.json();
            }
            throw "Failed non auth telemetry"
        })
    }

    reportTelemetry(payload, nonAuthUsername = 'unknown', infoParams = {}) {
        const platform = $build?.platform;
        const info = $requestUtil.infoReported ?
            undefined :
            {
                prod: $build?.env == 'production' ? 1 : 0,
                ...infoParams
            };

        const restTelemetry = [ 'web', 'desktop', 'ntws', 'marketing' ].includes(platform) || payload.useREST;
        delete payload.useREST;
        const sessionData = {
            wa_session: uuid,
            sstm,
            t: now() - sstm
        }
        let data = {...payload, ...sessionData};
        if(!restTelemetry) {
            $app.send({action: 'web_app_telemetry', data});
        } else {
            $requestUtil.infoReported = true;
            const body = {
                sstm,
                info,
                data
            };
            if(infoParams && infoParams.authenticated === false) {
                return this.nonAuthTelemetry({ user: nonAuthUsername, ...body });
            }
            return this.request('telemetry/authAdd', {
                method: 'POST',
                body: JSON.stringify(body)
            })
            .then(r => {
                if(!r.ok && ["401", "400"].includes(r.status?.toString() || r.statusCode?.toString())) {
                    return this.nonAuthTelemetry({ user: nonAuthUsername, ...body });
                } else if(!r.ok) {
                    throw "Failed auth telemetry"
                } else {
                    return r.json()
                }
            })
            .catch(v => {
                console.log(v);
            })
        }
    }

}

const instance = new Requester();

export const ibotFeedback = (feedback_context, feedback_originator, feedback) => {
    return instance.request('faq/feedback', {
        method: 'POST',
        body: JSON.stringify({
            "@type": "feedback",
            "feedback": feedback || 1,
            feedback_context,
            feedback_originator
        })
    })
}

//exception reporter Vue plugin, requires injection in index.js of app
const reportException = (options, message, info) => {
    const i = {
        webAppId: options.webAppId,
        userAgent: window?.navigator?.userAgent,
        navigatorPlatform: window?.navigator?.platform,
        navigatorAppVersion: window?.navigator?.appVersion,
        ibTheme: $app.option.theme,
        ibPlatform: $build.platform,
        ibLang: $app.option.language,
        ibMedia: $media,
        ibDevice: $device,
        cpRegion: window.region,
        errorType: 'error',
        errorMessage: message?.stack || message,
        errorInfo: info || null,
        gitRev: $build?.rev
    };
    instance.reportTelemetry({ a: 'webui_error', i, c: i.webAppId });
}

export const exceptionReporter = {
    install(Vue, options) {
        Vue.config.errorHandler = function(message, vm, info) {
            reportException(options, message, info);
        };
        window.onerror = (error) => {
            reportException(options, error, 'window error');
        };
    }
}

export default instance;
